function columnSort(aCol, bCol) {
	return aCol.index - bCol.index;
}

var store = {
	namespaced: true,
	state: {
		query: {
			search: '',
			sort: {
				type: 'default',
				asc: false
			},
			filter: {
				type: 'daterange',
				date: null
			},
			folder: null
		},
		sidebar: {
			active: false
		},
		counter: {
			noteCount: 0,
			total: 0
		},
		selectedNote: {
			id: null,
			trigger: false
		},
		gridColumns: [
			{
				name: 'Date',
				key: 'date',
				index: 0,
				width: 100
			},
			{
				name: 'Text',
				key: 'text',
				index: 1,
				width: 420
			},
			{
				name: 'Comment',
				key: 'comment',
				index: 2,
				width: 420
			},
			{
				name: 'Bucket',
				key: 'bucket',
				index: 3,
				width: 150
			},
			{
				name: 'Folder',
				key: 'folder',
				index: 4,
				width: 150
			},
			{
				name: 'Controls',
				key: 'controls',
				index: 5,
				width: 150
			}
		],
		drag: false,
		view: 'reading', // can be 'grid' too,
		groupStrategy: 'domains',

		computedNotes: []
	},
	getters: {
		folder: function(state) {
			return state.query.folder;
		},
		listView: function(state) {
			return state.view;
		},
		query: function(state) {
			return state.query;
		},
		search: function(state) {
			return state.query.search;
		},
		dateFilter: function(state) {
			return state.query.filter.date;
		},
		sidebar: function(state) {
			return state.sidebar.active;
		},
		counter: function(state) {
			return state.counter;
		},
		noteCount: function(state) {
			return state.counter.noteCount;
		},
		selectedNote: function(state, getters, rootState, rootGetters) {
			if (state.selectedNote.id) {
				return rootGetters['note/note'](state.selectedNote.id);
			} else {
				return null;
			}
		},
		selectedNoteTrigger: function(state) {
			return state.selectedNote.trigger;
		},
		currentFolder: function(state, getters, rootState, rootGetters) {
			if (state.query.folder) {
				return rootGetters['folder/folder'](state.query.folder);
			} else {
				return null;
			}
		},
		computedNotes: function(state) {
			return state.computedNotes;
		},
		gridColumns: function(state) {
			return state.gridColumns.sort(columnSort);
		},
		drag: function(state) {
			return state.drag;
		},
		groupStrategy: function(state) {
			return state.groupStrategy;
		}
	},
	mutations: {
		UPDATE_SEARCH: function(state, search) {
			state.query.search = search;
		},
		UPDATE_DATE_FILTER: function(state, date) {
			state.query.filter.date = date;
		},
		TOGGLE_SIDEBAR: function(state, mode) {
			if (!mode) {
				state.sidebar.active = !state.sidebar.active;
			} else {
				state.sidebar.active = mode;
			}
		},
		CLEAR_FILTERS: function(state) {
			state.query.filter.date = null;
		},
		UPDATE_NOTECOUNT: function(state, val) {
			state.counter.noteCount = val;
		},
		UPDATE_TOTAL: function(state, val) {
			state.counter.total = val;
		},
		SET_SELECTED_NOTE: function(state, noteId) {
			state.selectedNote.id = noteId;
		},
		SELECTED_NOTE_TRIGGER: function(state) {
			state.selectedNote.trigger = !state.selectedNote.trigger;
			1;
		},
		SET_FOLDER: function(state, folder) {
			if (folder) {
				state.query.folder = folder._id;
			} else {
				state.query.folder = null;
			}
		},
		SET_COMPUTED_NOTES: function(state, notes) {
			state.computedNotes = notes;
		},
		UPDATE_GRID_COLUMNS: function(state, gridColumns) {
			state.gridColumns = gridColumns;
		},
		SET_VIEW_STATE: function(state, view) {
			state.view = view;
		},
		SET_STATE: function(state, newState) {
			state = newState;
		},
		DRAG_STARTED: function(state) {
			state.drag = true;
		},
		DRAG_STOPPED: function(state) {
			state.drag = false;
		},
		SET_GROUP: function(state, groupStrategy) {
			state.groupStrategy = groupStrategy;
		}
	},
	actions: {
		init: function(context) {
			context
				.dispatch('cache/get', 'dashboardState', { root: true })
				.then(data => {
					if (data.dashboardState) {
						context.commit('SET_SETTINGS', data.dashboardState);
					}
				});
		},
		updateSearch: function(context, search) {
			context.commit('UPDATE_SEARCH', search);
		},
		updateDateFilter: function(context, date) {
			context.commit('UPDATE_DATE_FILTER', date);
		},
		toggleSidebar: function(context) {
			context.commit('TOGGLE_SIDEBAR');
		},
		clearFilters: function(context) {
			context.commit('CLEAR_FILTERS');
		},
		updateNotecount: function(context, val) {
			context.commit('UPDATE_NOTECOUNT', val);
		},
		updateTotal: function(context, val) {
			context.commit('UPDATE_TOTAL', val);
		},
		setSelectedNote: function(context, noteId) {
			context.commit('SET_SELECTED_NOTE', noteId);
			context.commit('SELECTED_NOTE_TRIGGER');
		},
		updateFolder: function(context, folder) {
			context.commit('SET_FOLDER', folder);
		},
		setComputedNotes: function(context, notes) {
			context.commit('SET_COMPUTED_NOTES', notes);
		},
		updateGridColumns: function(context, gridColumns) {
			context.commit('UPDATE_GRID_COLUMNS', gridColumns);
		},
		toggleListViewState: function(context, view) {
			context.commit('SET_VIEW_STATE', view);
			// context.dispatch(
			// 	"cache/save",
			// 	{
			// 		key: "dashboardState",
			// 		value: context.state,
			// 	},
			// 	{ root: true }
			// );
		},
		dragStarted: function(context) {
			context.commit('DRAG_STARTED');
		},
		dragStopped: function(context) {
			context.commit('DRAG_STOPPED');
		},
		setGroup: function(context, groupStrategy) {
			context.commit('SET_GROUP', groupStrategy);
		}
	}
};

export default store;
